import type { SVGProps } from "react";

type ModeIconProps = SVGProps<SVGSVGElement> & {
  strokeWidth?: number;
};

export function ReadonlyIcon({ strokeWidth = 1.8, ...props }: ModeIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      aria-hidden="true"
      {...props}
    >
      <rect x="3.5" y="4" width="17" height="13" rx="2.5" />
      <path d="M6.8 8h10.4" />
      <path d="M6.8 11h8.2" />
      <path d="M6.8 14h5.4" />
      <rect x="13.4" y="14.6" width="6.6" height="5.2" rx="1.2" />
      <path d="M15.3 14.6v-1a1.4 1.4 0 0 1 2.8 0v1" />
    </svg>
  );
}

export function CompactIcon({ strokeWidth = 1.8, ...props }: ModeIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      aria-hidden="true"
      {...props}
    >
      <rect x="3.5" y="3.5" width="17" height="17" rx="2.5" />
      <path d="M12 6.6v3.2" />
      <path d="M10.8 8.6 12 9.8l1.2-1.2" />
      <path d="M12 17.4v-3.2" />
      <path d="M10.8 15.4 12 14.2l1.2 1.2" />
      <path d="M6.6 12h3.2" />
      <path d="M8.6 10.8 9.8 12l-1.2 1.2" />
      <path d="M17.4 12h-3.2" />
      <path d="M15.4 10.8 14.2 12l1.2 1.2" />
    </svg>
  );
}
